module.exports = __webpack_public_path__ + "img/ready.cab3dfcc.png";